export function fmtBytes(n) {
  if (!n && n !== 0) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(2)} MB`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const KIND_STYLES = {
  daily: "bg-sky-500/10 text-sky-600 dark:text-sky-400 border-sky-500/30",
  weekly: "bg-violet-500/10 text-violet-600 dark:text-violet-400 border-violet-500/30",
  monthly: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30",
  manual: "bg-secondary text-foreground border-border",
};
